var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-to-top",style:({
    bottom: _vm.bottom + 'px',
    right: _vm.right + 'px'
  }),on:{"click":_vm.toTop}},[_c('mk-iconfont',{staticClass:"icon",attrs:{"icon-class":"huidaodingbu"}}),_vm._v("\n  回到顶部\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }